import React from 'react';
import { useSelector } from 'react-redux';

import styles from './RMLConnection.module.scss';
import config from '../../config/config';
import { getHasRelationshipManager } from '../../redux/modules/manager/relationshipManager.selectors';
import RMLink from '../RMLink/RMLink';
import telephoneImg from '../../assets/images/telphone.svg';

const RMLConnection = ({ phoneNumber, phoneStyleName, landingPage }) => {
  const hasRelationshipManager = useSelector(getHasRelationshipManager);

  if (hasRelationshipManager) {
    return (
      <div
        className={`${styles['RML-wrapper']} ${
          !landingPage && styles['destination-steps-text']
        }`}
      >
        <RMLink />
      </div>
    );
  }
  return (
    <div
      className={`${styles['phone-link-wrapper']} ${
        !landingPage && styles['destination-steps-text']
      }`}
    >
      <div>
        <img
          alt="phone-icon"
          src={telephoneImg}
          className={styles['phone-icon']}
        />
      </div>
      <div className={styles['phone-div']}>
        <a
          href={`${config.url}/personal-investing/help/contact/index.html`}
          rel="noopener noreferrer"
          target="_blank"
          className={styles['contact-us-link']}
        >
          Contact us
        </a>{' '}
        <span> for help with your Auto-RMD.</span>
      </div>
    </div>
  );
};

export default RMLConnection;
